import { lazy, Suspense } from "react";
import { Route } from "react-router-dom";
import ProtectedRoute from "../components/common/ProtectedRoute";
import PublicLayout from "../components/common/PublicLayout";
import PageLoader from "../components/common/PageLoader";

const HomePage = lazy(() => import("../components/pages/HomePage"));
const SignupPage = lazy(() => import("../components/users/SignupPage"));
const LoginPage = lazy(() => import("../components/users/LoginPage"));
const UserProfile = lazy(() => import("../components/users/UserProfile"));
const Products = lazy(() => import("../components/product/Products"));
const Cart = lazy(() => import("../components/pages/CartPage"));
const ProductDetails = lazy(() => import("../components/product/ProductDetails"));
const CheckoutPage = lazy(() => import("../components/pages/CheckoutPage"));
const OrderConfirmation = lazy(() => import("../components/pages/OrderConfirmation"));
const Orders = lazy(() => import("../components/pages/Orders"));
const WishlistPage = lazy(() => import("../components/pages/WishlistPage"));
const OffersPage = lazy(() => import("../components/pages/OfferPage"));
const SettingsPage = lazy(() => import("../components/pages/SettingsPage"));
const TopSellerDetailsPage = lazy(() => import("../components/pages/TopSellerDetailsPage"));
const SellerRegister = lazy(() => import("../components/pages/seller/SellerRegister"));
const SellerLogin = lazy(() => import("../components/pages/seller/SellerLogin"));
const AdminLogin = lazy(() => import("../components/pages/admin/AdminLogin"));

const PublicRoutes = () => (
  <>
    {/* Navbar + Footer wale pages */}
    <Route element={<PublicLayout />}>
      <Route path="/" element={<HomePage />} />
      <Route path="/products" element={<Products />} />
      <Route path="/all-products" element={<Products />} />
      <Route path="/productDetails/:id" element={<ProductDetails />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/wishlist" element={<WishlistPage />} />
      <Route path="/offers" element={<OffersPage />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/top-seller/:id" element={<TopSellerDetailsPage />} />
      <Route path="/orders" element={<Orders />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/seller/register" element={<SellerRegister />} />

      {/* Protected (Navbar + Footer ke saath) */}
      <Route element={<ProtectedRoute />}>
        <Route path="/order/:id" element={<OrderConfirmation />} />
        <Route path="/profile" element={<UserProfile />} />
      </Route>
    </Route>

    {/* Bina Navbar/Footer ke */}
    <Route
      path="/seller/login"
      element={
        <Suspense fallback={<PageLoader />}>
          <SellerLogin />
        </Suspense>
      }
    />
    <Route
      path="/admin/login"
      element={
        <Suspense fallback={<PageLoader />}>
          <AdminLogin />
        </Suspense>
      }
    />

    <Route
      path="/unauthorized"
      element={
        <div className="flex items-center justify-center h-screen">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-red-600">Unauthorized Access</h1>
            <p className="text-gray-600 mt-2">
              You don't have permission to view this page.
            </p>
          </div>
        </div>
      }
    />
  </>
);

export default PublicRoutes;
